import React from 'react';

export const CANCEL_NOT_PAID_DESCRIPTION =
  'The customer has not paid for this order yet, so you cannot issue a refund. Please specify the cancellation reason, along with an optional note.';

// keeping because we had this in the platform originally - not currently in use
export const CANCEL_PAYMENT_NOT_CAPTURED_DESCRIPTION =
  'The payment has not been captured for this order yet, so you cannot issue a refund. Please specify the cancellation reason, along with an optional note.';

export const CANCEL_PAID_AND_SHIPPED_DESCRIPTION =
  "The customer has paid for this order, and the items have been shipped. You cannot issue a refund at this time, but you can cancel the order, and the partner will be able to issue a refund once they've received the returned items. Please specify the cancellation reason, along with an optional note.";

export const CANCEL_PAID_NOT_SHIPPED_DESCRIPTION = (
  <div className="col-md-12 page-text cancel-order-desc">
    The customer has paid for this order, but it has not shipped, so you can issue a refund along with the cancellation.
    Please update the number of items and the shipping amount that you'd like to refund, or adjust the total to refund a
    specific dollar amount. If you wish to cancel the entire order without issuing a refund, leave all values at 0.{' '}
    <br />
    Don't forget to specify the reason for the cancellation.
  </div>
);

export const REFUND_DESCRIPTION = (
  <div className="col-md-12 page-text cancel-order-desc">
    The customer has paid for this order, but it has shipped, so you can issue a refund. Please update the number of
    items and the shipping amount that you'd like to refund, or adjust the total to refund a specific dollar amount.{' '}
    <br />
    Please add a note to describe the reason for refunding the order.
  </div>
);

export const SHOPIFY_FINANCIAL_STATUSES = {
  PAID: 'paid',
  REFUNDED: 'refunded',
  PARTIALLY_REFUNDED: 'partially_refunded',
  PARTIALLY_PAID: 'partially_paid',
  SHIPPING_REFUND: 'shipping_refund',
  PENDING: 'pending',
};
